type KillswitchConfig = {
  oneTrustDisabled: boolean;
  datadogDisabled: boolean;
  launchdarklyDisabled: boolean;
  supportDisabled: boolean;
  heapDisabled: boolean;
};

const castBooleanFromString = (value: string | undefined): boolean => {
  /*
    Octopus only passes strings back and will also pass back a template literal if the value is 
    not set as a variable, we need to make sure we have deliberately set something to true. 
    Also handlebars needs a boolean value to evaluate against so we are checking explicitly if the 
    string is true and also casting to a boolean. 
  */

  return value === 'true';
};

export const KILLSWITCH_CONFIG: KillswitchConfig = {
  oneTrustDisabled: castBooleanFromString(window.__app_config.WEBUI_ONETRUST_DISABLED),
  datadogDisabled: castBooleanFromString(window.__app_config.WEBUI_DATADOG_DISABLED),
  launchdarklyDisabled: castBooleanFromString(window.__app_config.WEBUI_LAUNCHDARKLY_DISABLED),
  supportDisabled: castBooleanFromString(window.__app_config.WEBUI_SUPPORT_BOT_DISABLED),
  heapDisabled: castBooleanFromString(window.__app_config.WEBUI_HEAP_DISABLED),
};
